import { EnvironmentProviders, Injectable, inject, provideAppInitializer } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentKeys } from 'src/environments/environment-keys';

@Injectable()
export class ConfigService {

    private _config!: Record<string, boolean | number | string>;
    private httpClient = new HttpClient(inject(HttpBackend));

    public load(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const uniqueParam = new Date().getTime();

            this.httpClient.get<Record<string, boolean | number | string>>(
                environment.configSource!,
                {
                    params: { nocache: uniqueParam.toString() },
                }
            ).pipe(take(1)).subscribe({
              next: (data: Record<string, boolean | number | string>) =>
              {
                this._config = data;
                resolve(true);
              },
              error: (error) => {
                reject(`Error loading config: ${error}`);
              },
            })
        });
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    public getConfig(key: EnvironmentKeys | string): any {
        const keys = key.split('.');

        if(!this._config) {
            throw new Error(`No JSON config loaded while accessing key "${key}".`);
        }

        if(keys.length === 1) {
            return this._config[key];
        }

        let value = this._config;

        for (const nestedKey of keys) {
            value = value[nestedKey] as any;

            if (value === undefined) {
                break;
            }
        }

        if((!value || value === null) && value !== '' && value !== 0) {
            console.warn(`Value not found in provided JSON config. Looked for key "${key}" found "${value}" (${typeof value}).`);
        }

        return value;
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */
}

export const provideConfig = (): EnvironmentProviders => provideAppInitializer(() => {
  const service: ConfigService = inject(ConfigService);
  return service.load();
});
